export const toNumber = (value, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const getSubtotal = (item) => {
  const quantity = toNumber(item.quantity);
  const price = toNumber(item.price);
  return quantity * price * (1 - toNumber(item.discountPercentage) / 100);
};

export const buildEmptyItem = (isImport) => ({
  quantity: 0,
  price: 0,
  productId: null,
  unitId: null,
  concept: "",
  workOrderId: "",
  taxRate: isImport ? 0 : 16,
  discountPercentage: 0,
  subtotal: 0,
  expenseAccountId: "",
});

export const buildItemPayload = (item, purchaseOrderId) => ({
  purchaseOrderId,
  expenseAccountId: toNumber(item.expenseAccount?.id ?? item.expenseAccountId),
  workOrderId: item.workOrderId || null,
  productId: item.product?.id ?? item.productId ?? null,
  unitId: item.unit?.id ?? item.unitId,
  concept: item.concept || "",
  quantity: toNumber(item.quantity),
  price: toNumber(item.price),
  discountPercentage: toNumber(item.discountPercentage),
  assetTypeId: item.assetTypeId || null,
  assetId: item.assetId || null,
  taxRate: toNumber(item.taxRate),
});

export const buildRowId = (item, index) =>
  item.__rowId ?? item.id ?? item.Id ?? `row-${index}`;

export const mapItemToRow = (item, index, isImport) => ({
  ...item,
  id: buildRowId(item, index),
  expenseAccount:
    item.expenseAccount ||
    (item.expenseAccountId
      ? { id: item.expenseAccountId, code: "", name: "", contpaqiCode: "" }
      : null),
  unit: item.unit || (item.unitId ? { id: item.unitId, code: "" } : null),
  product: item.product || (item.productId ? { id: item.productId, code: "" } : null),
  quantity: toNumber(item.quantity),
  price: toNumber(item.price),
  taxRate: toNumber(item.taxRate, isImport ? 0 : 16),
  subtotal: getSubtotal(item),
});

export const normalizeSavedItem = (values, persistedItem, isImport) => {
  const persistedId = persistedItem?.id ?? persistedItem?.Id;
  return {
    ...buildEmptyItem(isImport),
    ...values,
    ...persistedItem,
    id: persistedId,
    Id: persistedId,
    expenseAccount: values.expenseAccount || persistedItem?.expenseAccount || null,
    unit: values.unit || persistedItem?.unit || null,
    product: values.product || persistedItem?.product || null,
    expenseAccountId:
      values.expenseAccount?.id ||
      values.expenseAccountId ||
      persistedItem?.expenseAccountId ||
      "",
    unitId: values.unit?.id || values.unitId || persistedItem?.unitId || "",
    productId:
      values.product?.id || values.productId || persistedItem?.productId || null,
    quantity: toNumber(values.quantity),
    price: toNumber(values.price),
    taxRate: toNumber(values.taxRate, isImport ? 0 : 16),
    __rowId: persistedId,
    subtotal: getSubtotal({ ...values, ...persistedItem }),
  };
};
